<template>
  <boxwrap  class="point-list--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <select-list
          class="toolbar-nav"
          :title="$route.params.status"
          v-model="selectedList"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>
          <select-option
            :value="type.name"
            :name="type.name"
            v-for="type in types"
            :key="type.id"
          >
            <span>{{type.name}}</span>
          </select-option>
        </select-list>

        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
      </toolbar-items>
    </toolbar>
    <boxwrap-contents>

      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
        :class="{'data-loading': showDataLoading}"
        v-else
      >
        <tbl-inner>
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="no"
                :sort="true"
                @click.native="sort('id')"
              >
                no
              </tbl-td>

              <tbl-td
                name="new-point"
                :sort="true"
                @click.native="sort('new_point')"
              >
                new-point
              </tbl-td>

              <tbl-td
                name="old-point"
                :sort="true"
                @click.native="sort('old_point')"
              >
                old-point
              </tbl-td>

              <tbl-td
                name="amount"
                :sort="true"
                @click.native="sort('amount')"
              >
                amount
              </tbl-td>

              <tbl-td
                name="login-id"
              >
                login-id
              </tbl-td>

              <tbl-td
                name="login-user"
              >
                login-user
              </tbl-td>

              <tbl-td
                :sort="true"
                @click.native="sort('point_type.name')"
                name="division"
              >
                division
              </tbl-td>

              <tbl-td
                name="status"
                :sort="true"
                @click.native="sort('status')"
              >
                status
              </tbl-td>

              <tbl-td
                name="admin-ip"
                :sort="true"
                @click.native="sort('ip')"
              >
                admin-ip
              </tbl-td>

              <tbl-td
                name="from"
                :sort="true"
                @click.native="sort('domain')"
              >
                domain
              </tbl-td>

              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('created_at')"
              >
                created-at
              </tbl-td>

            </tbl-row>
          </tbl-head>
          <tbl-body>
            <tbl-row
              v-for="(point,x) in pointList"
              :key="point.id"
            >
              <tbl-td name="no">
                {{point.id}}
              </tbl-td>

              <tbl-td name="new-point">
                <span> {{point.new_point | FormatAmount('whole')}} </span>
              </tbl-td>

              <tbl-td name="old-point">
                {{point.old_point | FormatAmount('whole')}}
              </tbl-td>

              <tbl-td name="amount">
                {{point.amount | FormatAmount('whole')}}
              </tbl-td>

              <tbl-td
                name="login-id"
                @click.native="openUser(point.user.id, 'info/undeleted')"
              >
                <span v-if="point.user">{{point.user.login_id}}</span>
                <span v-else>-</span>
              </tbl-td>

              <tbl-td
                name="login-id"
                @click.native="openUser(point.user.id, 'bet-history/all')"
              >
                <span v-if="point.user">{{point.user.login_name}}</span>
                <span v-else>-</span>
              </tbl-td>

              <tbl-td name="division">
                {{point.type}}
              </tbl-td>

              <tbl-td name="result">
                {{point.status | status}}
              </tbl-td>

              <tbl-td name="admin-ip">
                <span v-if="point.ip">{{point.ip}}</span>
                <span  v-else>-</span>
              </tbl-td>

              <tbl-td name="from">
                <span v-if="point.domain">{{point.domain}}</span>
                <span  v-else>-</span>
              </tbl-td>

              <tbl-td name="created-at">
                {{point.created_at | date}}
              </tbl-td>

            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="count"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>

      </tbl>
    </boxwrap-contents>
  </boxwrap>
</template>
<script type="text/javascript">
import { mapState, mapActions } from 'vuex'

import Checkbox from '@/components/base/Checkbox'
import Modal from '@/components/base/Modal'
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'

//= filters
import FormatAmount from '@/assets/js/filters/FormatAmount'

export default {
  name: 'points-list',

  components: {
    Checkbox,
    Pagination,
    Search,
    CheckDataList
  },

  filters: {
    FormatAmount,
    status (stat) {
      let status = ''
      switch (stat.toLowerCase()) {
        case 'c':
          status = 'confirmed'
          break
        case 'r':
          status = 'rejected'
          break
        case 'w':
          status = 'waiting'
          break
        case 'p':
          status = 'pending'
          break
        case 'b':
          status = 'ban'
          break
        case 'd':
          status = 'deleted'
          break
      }
      return status
    }
  },

  computed: {
    ...mapState('points', ['pointList', 'count', 'types'])
  },

  async created () {
    await this.getTypes()
    this.search()
  },

  data () {
    let params = Object.assign(
      {
        rows: 50,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      selectedList: this.$route.params.status,

      filterBy: [
        {
          value: 'ip',
          display: 'ip'
        },

        {
          value: 'domain',
          display: 'domain'
        },

        {
          value: 'status',
          display: 'status'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created date'
        }
      ]
    }
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.params = this.generate($router.query)
      this.search()
    }
  },

  methods: {
    ...mapActions('points', {
      getPoints: 'get',
      getTypes: 'getTypes'
    }),
    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },
    clear () {

    },

    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.params = query || this.params
      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getPoints({
        params: this.params,
        type: 'all'
      })

      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.pointList.length) {
        this.isEmpty = true
      }
    },

    openUser (id, subtype) {
      window.open(
        `${process.env.VUE_APP_URL}/user/${id}/${subtype}`,
        '',
        `width=${1400},height=${window.innerHeight}`
      )
    }
  }
}
</script>
